/**
 * modules
 */

import preloader from '../../../templates/_atoms/preloader/_script';
import codeSnippet from '../../../templates/_atoms/codeSnippet/_script';
import imageSlider from '../../../templates/_organisms/imageSlider/_script';
import imageGallery from '../../../templates/_organisms/imageGallery/_script';
import weather from '../../../templates/_molecules/weather/_script';
import appHeader from '../../../templates/_organisms/appHeader/_script';
import schedule from '../../../templates/_molecules/schedule/_script';
import events from '../../../templates/_organisms/events/_script';
import tickets from '../../../templates/_molecules/tickets/_script';
import contactForm from '../../../templates/_organisms/contactForm/_script';
import announcement from '../../../templates/_atoms/announcement/_script';
import waterTemperature from '../../../templates/_molecules/waterTemperature/_script';
// import accordion    from '../../../templates/_templates/accordion/_main'
// import cookiebar    from '../../../templates/_modules/cookiebar/_main'
// import imageSlider  from '../../../templates/_modules/imageSlider/_main'
// import imageGallery from '../../../templates/_modules/imageGallery/_main'
// import navCategories from '../../../templates/_modules/navCategories/_main'

// Modules Array
const modulesArray = [
    preloader,
    codeSnippet,
    imageSlider,
    imageGallery,
    weather,
    appHeader,
    schedule,
    events,
    tickets,
    contactForm,
    announcement,
    waterTemperature,
    // accordion,
    // cookiebar,
    // imageGallery,
    // navCategories
];

const modules = {
    // Modules
    Modules() {
        if (modulesArray.length > 0 && modulesArray !== undefined) {
            modulesArray.forEach((module) => {
                try {
                    module.init();
                } catch (e) {
                    // verhindert Kaskadeneffekt bei einem fehlenden Modul
                }
            });
        }
    },

    init() {
        this.Modules();
    }
};

export default modules;



// WEBPACK FOOTER //
// ./___src/assets/js/partials/modules.js